import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 获奖组件属性接口 */
export type WinnerAttrs = BaseComponentAttrs;

/** 获奖组件类 */
export class WinnerComponent extends BaseComponent<WinnerAttrs> {
  constructor(data: Partial<BaseComponent<WinnerAttrs>> = {}) {
    super(data);
    this.type = CompType.winner;
  }
}
